import { render, staticRenderFns } from "./RecommendablePersonPage.vue?vue&type=template&id=15cb98d2&scoped=true"
import script from "./RecommendablePersonPage.vue?vue&type=script&lang=js"
export * from "./RecommendablePersonPage.vue?vue&type=script&lang=js"
import style0 from "./RecommendablePersonPage.vue?vue&type=style&index=0&id=15cb98d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cb98d2",
  null
  
)

export default component.exports